import "firebase/analytics";
import "firebase/database";
import app from "firebase/app";

const config = {
    apiKey: process.env.REACT_APP_API_KEY,
    databaseURL: process.env.REACT_APP_DATABASE_URL,
    projectId: process.env.REACT_APP_PROJECT_ID,
    appId: "1:193040437016:web:732661c298150f2fbd586d",
};

class Firebase {
    constructor() {
        app.initializeApp(config);

        this.db = app.database();

        app.analytics();
    }

    // Boards API
    board = slug => this.db.ref(`boards/${slug}`);
}

export default Firebase;
